import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { OrderForListing } from '../../models/OrderForListing';
import { SeparationType } from '../../enums/SeparationType';

interface IRecipePopoverProps {
  separationType?: SeparationType;
  orderForListing: OrderForListing;
}

export const RecipePopover: React.FC<IRecipePopoverProps> = ({
  separationType,
  orderForListing
}) => {

  return separationType === SeparationType.Prescription && orderForListing.allLensesArePlan ?
    <span style={{ marginLeft: '5px' }}>
      <OverlayTrigger
        placement="right"
        delay={{ show: 250, hide: 400 }}
        overlay={<Tooltip>Lentes planas</Tooltip>}
      >
        <span><FontAwesomeIcon icon={faInfoCircle} color='gray' size='sm' /></span>
      </OverlayTrigger>
    </span>
  : null;

}